import styled from "styled-components";
import {
  CommonCardListWrapper,
  commonClientBalanceCardStyle,
} from "../../atom";

export const PictureRechargeGiftWrapper = styled.div`
  position: relative;
  .card-list-wrapper {
    overflow-x: hidden;
  }
`;
export const CardListContent = styled.div`
  position: relative;
  .scroll-button {
    position: absolute;
    cursor: pointer;
    top: 0;
    bottom: 0;
    margin: auto 0;
    z-index: 10;
  }

  .left-button {
    left: -10px;
  }

  .right-button {
    right: -10px;
  }
`;
export const PictureRechargeGiftCardList = styled(CommonCardListWrapper)`
  width: max-content;
  padding-right: 10px;
`;

export const PictureRechargeGiftCard = styled(commonClientBalanceCardStyle)`
  height: 147px;
  justify-content: flex-start;
  padding-top: 16px;
`;
